import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as moment from 'moment';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

moment.locale('pt-br');

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.log(err));
